import { Component, OnInit, Input, Output, EventEmitter, HostBinding, ContentChild, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';

/**
 * The basic design for viega dialogs with rich content.
 * Provides a header with a title and viega logo aswell as a close button.
 */
@Component({
    selector: 'viega-dialog-wrapper',
    templateUrl: './viega-dialog-wrapper.component.html',
    styleUrls: ['./viega-dialog-wrapper.component.scss']
})
export class ViegaDialogWrapperComponent {
    @Input()
    public heading: string = "";

    @ContentChild('header')
    public headerTemplate: TemplateRef<any>;

    @Input()
    @HostBinding("class.logo-hidden")
    public hideLogo: boolean = true;

    @Input()
    public hideCloseButton: boolean = false;

    @Input()
    public overflowX: string = 'hidden';

    @Input()
    public overflowY: string = 'auto';

    @Output()
    public requestClose = new EventEmitter();

    constructor(private dialog: MatDialog) {}

    public requestDialogCloseBound = this.requestDialogClose.bind(this);
    public requestDialogClose() {
        this.requestClose.emit();
    }
}



// WEBPACK FOOTER //
// ./src/viega-common/components/viega-dialog-wrapper/viega-dialog-wrapper.component.ts